/* tslint:disable */
/* eslint-disable */
export enum WorkDebtorCamtMatchStatusEnum {
  Full = 'full',
  Partial = 'partial',
  Overpaid = 'overpaid',
  AlreadyPaid = 'already_paid',
  NotFound = 'not_found'
}
